module.exports = __webpack_public_path__ + "static/csv-video-c57aaa1269d18b9afb68fbae5ab22faf.webm";